<template>
  <div class="course-list">
    <Form :model="searchData" inline @submit.native.prevent="getData(1)" :label-width="100">
      <FormItem label="名称">
        <Input v-model="searchData.name" clearable />
      </FormItem>
      <FormItem label="级别">
        <Select
          v-model="searchData.grade_id"
          filterable
          clearable
          placeholder="请选择级别"
          style="width: 180px"
        >
          <Option
            v-for="item in scopeGradeList"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="科目">
        <Select
          v-model="searchData.subject_id"
          filterable
          clearable
          placeholder="请选择科目"
          style="width: 180px"
        >
          <Option
            v-for="item in scopeSubjectList"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </FormItem>
      <div style="display: inline-block; margin-left: 10px">
        <Button type="primary" icon="ios-search" html-type="submit">
          搜索
        </Button>
      </div>
    </Form>
      <Table
        class="course-table online-course-table"
        :columns="tableColumns"
        :data="tableData.data"
        :loading="tableLoading"
        border
      >
      <template slot-scope="{ row }" slot="index">
        {{ (tableData.current_page - 1) * 10 + row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="buy_count">
        {{ row.buy_count + row.false_num }}
      </template>
      <template slot-scope="{ row }" slot="name">
        <a v-if="row.instro" @click="looks(row.instro)">{{ row.name }}</a>
        <span v-else>{{ row.name }}</span>
      </template>
      <template slot-scope="{ row }" slot="action">
        <Poptip
          v-auth="'admin/delete'"
          transfer
          confirm
          title="您确定要报名缴费吗？"
          @on-ok="jiaofei(row.id)"
        >
          <Button
            type="primary"
            v-if="row.is_buy == 0"
            style="margin-left: 5px"
            size="small"
            >报名缴费</Button
          >
        </Poptip>
        <Button
          type="info"
          size="small"
          v-if="row.is_buy == 1"
          @click="clickway(row)"
          >上课方式</Button
        >
      </template>
      </Table>
    <Page
      class="course-pagination"
      :total="tableData.total"
      :page-size="tableData.per_page"
      :current="tableData.current_page"
      show-total
      @on-change="getData"
    />
    <Modal title="上课简介" v-model="visible">
      <div v-html="contents" style="width: 100%" />
      <div slot="footer">
        <Button type="text" size="small" @click="visible = false">取消</Button>
      </div>
    </Modal>
    <Modal v-model="lookShow" @on-cancel="lookShow = false" title="上课方式">
      <Row>
        <Col span="24" style="max-height:70vh;overflow:auto">
          <div v-html="looksInfo.class_way"></div>
        </Col>
      </Row>
      <div slot="footer">
        <Button type="text" size="small" @click="lookShow = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import indexPage from "../../mixins/indexPage";
import scopeSearch from "../../mixins/scopeSearch";
export default {
  mixins: [indexPage, scopeSearch],
  computed: {
    ...mapState({
      gradeList(state) {
        return state.global.gradeList;
      },
      subjectList(state) {
        return state.global.subjectList;
      }
    })
  },
  data() {
    return {
      searchData: {},
      contents: "",
      visible: false,
      looksInfo: {},
      lookShow: false,
      tableColumns: [
        { title: "序号", slot: "index", width: 80, align: "center" },
        { title: "面授课程", slot: "name", align: "center", minWidth: 120 },
        {
          title: "课时总数",
          key: "class_hours",
          align: "center",
          minWidth: 120
        },
        { title: "级别", key: "grade_name", align: "center", minWidth: 120 },
        { title: "科目", key: "subject_name", align: "center", minWidth: 120 },
        {
          title: "任教老师",
          key: "teacher_name",
          align: "center",
          minWidth: 120
        },
        {
          title: "上课时间",
          key: "teaching_time",
          align: "center",
          minWidth: 120
        },
        {
          title: "原价",
          key: "original_price",
          align: "center",
          minWidth: 120
        },
        { title: "售价", key: "current_price", align: "center", minWidth: 120 },
        {
          title: "报名人数上限",
          key: "apply_num_limit",
          align: "center",
          minWidth: 120
        },
        {
          title: "已报名人数",
          slot: "buy_count",
          align: "center",
          minWidth: 120
        },
        { title: "操作", slot: "action", width: 160, align: "center" }
      ],
      indexUrl: "/app/online_course_appointment/index"
    };
  },
  mounted() {
    this.scopeSearchInit();
    // 初始化筛选列表
    this.$store.dispatch("global/getAllSelect");
  },
  methods: {
    looks(con) {
      this.visible = true;
      this.contents = con;
    },
    jiaofei(id) {
      var that = this;
      that.$axios
        .post("/app/online_course_appointment/buy?id=" + id)
        .then(res => {
          if (res.code == 1) {
            that.$Message.success("缴费成功");
            that.getData(that.tableData.current_page);
          } else {
            that.$Message.error(res.msg);
          }
        });
    },
    clickway(row) {
      this.looksInfo = {};
      this.lookShow = true;
      var that = this;
      that.$axios
        .get("/app/online_course_appointment/getInfo?id=" + row.id)
        .then(res => {
          if (res.code == 1) {
            that.looksInfo = res.data;
          } else {
            that.$Message.error(res.msg);
          }
        });
    }
  }
};
</script>
<style scoped>
.course-list {
  width: 100%;
  min-width: 0;
  min-height: 70vh;
  padding: 10px;
}

.course-table {
  width: 100%;
  min-width: 0;
  margin: 10px 0;
}

.course-pagination {
  padding-bottom: 10px;
  text-align: right;
}

.group-name:nth-child(n + 2)::before {
  content: " / ";
}
</style>
